export default "__VITE_ASSET__9dca189e__"